import { BridgeCallTimeoutException } from '@/ble/errors/bridgeCallTimeout'

// spjs ブリッジ呼び出しは「成功 / 失敗 / 無応答(settle しない)」の3値で失敗し得る（#7706。
// off リスナー・V14 write・死んだ機器への close で実測済みの既知病理）。無応答は catch でも
// try/finally でも防御できないため、ブリッジ越しの await は必ずこのヘルパーで上限を敷く。
// cap は「呼び出しの放棄」であって取り消しではない: ブリッジ呼び出し自体は裏で走り続け、
// 後から settle し得る（遅延 resolve は無視され、遅延 reject は先行 catch で握る）。
export function withBridgeCap<T>(
  call: Promise<T>,
  capMs: number,
  label: string
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => {
      // call.then の onRejected が withBridgeCap 呼び出し時に同期登録済みのため
      // 本来は冗長だが、防御の二重化として残す。
      call.catch(() => undefined)
      reject(new BridgeCallTimeoutException(label, capMs))
    }, capMs)
    call.then(
      (v) => {
        clearTimeout(timer)
        resolve(v)
      },
      (e) => {
        clearTimeout(timer)
        reject(e)
      }
    )
  })
}
